export default "__VITE_ASSET__Csr15QRb__"